<template>
	<main>
		<div v-if="masterListData" class="container">
			<MasterList
				v-if="!isMasterListLoading"
				:master-list="masterListData ?? []"
				@update:master-pk="onChangeMasterPk"
			/>

			<div class="section_characterInfo_container">
				<HomeItemLayout class="c_responsive">
					<ExpandableTitleBar
						:title="masterDetailData?.master?.master_trading_style ?? ''"
						:sub-title="masterDetailData?.master?.master_trading_description ?? ''"
						:has-view="false"
					/>
				</HomeItemLayout>
				<section v-if="masterDetailData" class="section_characterInfo">
					<img :src="masterDetailData?.master.file_path" class="characterInfo_img" alt="대가 일러스트" loading="lazy" />
					<div class="characterInfo_content">
						<p class="content_name">{{ masterDetailData?.master.master_name }}</p>
						<p class="content_motto">{{ masterDetailData?.master.master_motto }}</p>
					</div>
					<!-- <button v-if="subYn === 0" class="characterInfo_subBtn" @click="onClickPayment">구독하기</button> -->
					<!-- <p v-if="subYn === 1" class="characterInfo_subTxt">구독중</p> -->
				</section>
			</div>

			<section class="section_stock">
				<ToolTipTabBar :tab="STOCK_MENU_TAB_NOT_ALL_LIST" @update:master-event="onStockTabClick" />
				<div v-if="masterEventData" class="stock_lists">
					<!-- <div v-if="!subYn" class="list_guide">
						<p class="guide_txt">
							지금 구독하시고 대가의 <span>{{ `1위~${masterEventData?.master_investment.length - 3}위` }}</span
							>까지의 <br v-if="!displayStore.isDesktop" />종목을 확인해보세요!
						</p>
						<button v-if="subYn === 0" type="button" class="guide_btn" @click="onClickPayment">구독하기</button>
					</div> -->
					<PointList
						:data="
							!displayStore.isDesktop && subYn
								? masterEventData?.master_investment.slice(0, Number(moreNumber))
								: masterEventData?.master_investment
						"
						:sub-yn="subYn"
						:subscribe="subYn"
						:master-pk="Number(routePk)"
						@update:book-mark-refetch="onClickBookmark"
					/>
					<MoreButton
						v-if="Number(moreNumber) < masterEventData?.master_investment.length && !displayStore.isDesktop && subYn"
						class="btn_more"
						@click="onClickMoreButton"
					/>
				</div>
			</section>

			<section v-if="masterDetailData" class="section_achieve">
				<h2 class="achieve_title">대가의 업적</h2>
				<div class="achieve_content">
					<div v-dompurify-html="masterDetailData?.master?.master_feat" class="c_editorContent"></div>
				</div>
			</section>

			<section v-if="masterDetailData" class="section_rate">
				<h2 class="rate_title">대가의 수익률</h2>
				<div v-dompurify-html="masterDetailData?.master?.master_rate" class="rate_content c_editorContent"></div>
			</section>

			<section v-if="masterDetailData" class="section_rule">
				<h2 class="rule_title">대가의 투자원칙</h2>
				<div
					v-dompurify-html="masterDetailData?.master?.master_investment_rule"
					class="rule_content c_editorContent"
				></div>
			</section>

			<section v-if="masterDetailData" class="section_style">
				<h2 class="style_title">대가의 투자스타일</h2>
				<div
					v-dompurify-html="masterDetailData?.master?.master_investment_style"
					class="style_content c_editorContent"
				></div>
			</section>

			<section v-if="masterDetailData" class="section_ratio">
				<h2 class="ratio_title">대가의 투자 섹터 비중</h2>
				<DoughnutChart :chart-data="sectorChartData" :options="chartOption" />
				<!-- <div class="ratio_btn">
					<button
						v-if="subYn === 0"
						type="button"
						class="c_btn-primary c_btn-submit btn_subscribe"
						@click="onClickPayment"
					>
						구독하기
					</button>
				</div> -->
			</section>
		</div>
		<HomePopup :exposure-location="'master'" />
	</main>
</template>

<script setup lang="ts">
// 내부 라이브러리
import { computed, ref, watch, watchEffect } from 'vue';
// 외부 라이브러리
import { DoughnutChart } from 'vue-chart-3';
import { useRoute, useRouter } from 'vue-router';
import { Chart, registerables } from 'chart.js';

// api
import {
	GetMasterDetailSectorData,
	useGetMasterDetailApi,
	useGetMasterEventApi,
	useGetMasterListApi,
} from '@/api/master';
import MoreButton from '@/components/atom/button/MoreButton.vue';
import ExpandableTitleBar from '@/components/atom/tabBar/ExpandableTitleBar.vue';
import ToolTipTabBar from '@/components/atom/tabBar/ToolTipTabBar.vue';
import HomeItemLayout from '@/components/home/HomeItemLayout.vue';
import HomePopup from '@/components/popup/HomePopup.vue';
import MasterList from '@/components/rankList/MasterList.vue';
// component
import PointList from '@/components/rankList/PointList.vue';
// constant
import { STOCK_MENU_TAB_NOT_ALL_LIST } from '@/constants/title';
import { useDisplayStore } from '@/stores/display';
// import { useLoginPopupStore } from '@/stores/LoginPopup';
// store
// import { useTokenStore } from '@/stores/token';
// util
import { handleLinkClick } from '@/utils/directive/editorLinkOpenNewTab';

// -----variable-----
const route = useRoute();
const router = useRouter();
// const tokenStore = useTokenStore();
// const loginPopupStore = useLoginPopupStore();
const displayStore = useDisplayStore();

const subYn = ref(1);
const masterSectorLabel = ref<string[]>([]);
const masterSectorValue = ref<number[]>([]);
const contentBodies = ref<HTMLDivElement[]>([]);

const moreNumber = computed(() => {
	return route.query.more ?? 5;
});
const currentSubTab = computed(() => {
	return STOCK_MENU_TAB_NOT_ALL_LIST[route.query.tab ? Number(route.query.tab) : 0].current ?? 'SMA';
});
const routePk = computed(() => {
	return route.query.masterPk ?? '';
});

// -----api-----
const { data: masterListData, isLoading: isMasterListLoading } = useGetMasterListApi();
const { data: masterDetailData, refetch: refetchMasterDetail } = useGetMasterDetailApi(
	computed(() => {
		return {
			master_pk: Number(routePk.value),
		};
	})
);
const { data: masterEventData, refetch: refetchMasterEvent } = useGetMasterEventApi(
	computed(() => {
		return {
			master_pk: Number(routePk.value),
			sub_yn: subYn.value,
			master_investment_category: currentSubTab.value,
		};
	})
);
// -----chart
const customPaddingPlugin = {
	id: 'customPadding',
	beforeInit(chart: any) {
		const originalFit = chart.legend.fit;
		chart.legend.fit = function fit() {
			originalFit.bind(chart.legend)();
			this.height += 20;
		};
	},
};
const chartOption = ref({
	responsive: true,
	color: '#fff',
	plugins: {
		legend: {
			display: true,
			position: 'top',
			labels: {
				usePointStyle: true,
				pointStyle: 'rectRounded',
				font: {
					size: 13,
					weight: 300,
					lineHeight: '15.51px',
				},
			},
			align: displayStore.isDesktop ? 'center' : 'start',
			onClick: (e: Event) => {
				e.stopPropagation;
			},
		},
		customPadding: {},
	},
});
const sectorChartData = computed(() => ({
	labels: masterSectorLabel.value,
	datasets: [
		{
			data: masterSectorValue.value,
			backgroundColor: [
				'#01A9FF',
				'#FFB83F',
				'#FF5946',
				'#DBAEFF',
				'#A9F4D0',
				'#2B8B5D',
				'#F49698',
				'#FEFFD5',
				'#CFD096',
				'#EAEAEA',
				'#3E61FF',
			],
			borderColor: 'transparent',
		},
	],
}));
Chart.register(...registerables, customPaddingPlugin);

// -----function-----
// 북마크 클릭 시 리스트 리패치 함수
const onClickBookmark = async () => {
	await refetchMasterEvent();
};
// 마스터 클릭 시, 실행 함수
const onChangeMasterPk = async (pk: number) => {
	router.replace({ query: { masterPk: pk } });
	if (masterListData.value) {
		subYn.value = masterListData.value.master_list_onsub.some((item) => item.master_pk === Number(routePk.value))
			? 1
			: 0;
	}
	masterSectorLabel.value = [];
	masterSectorValue.value = [];
};
// 구독하기 버튼 클릭 시 실행 함수
// const onClickPayment = () => {
// 	if (!tokenStore.isLogin) {
// 		loginPopupStore.openPopup({
// 			icon: 'alert',
// 			content: LOGIN_REQUIRED_PAGE,
// 			confirm: () =>
// 				router.push({
// 					name: 'auth/login',
// 					query: {
// 						isPayment: 'true',
// 					},
// 				}),
// 			confirmText: CONFIRM_LOGIN,
// 			cancelText: CANCEL,
// 		});
// 	} else {
// 		router.push('/payment');
// 	}
// };
// 주식 탭 클릭 시 실행 함수
const onStockTabClick = async (idx: number) => {
	const current = STOCK_MENU_TAB_NOT_ALL_LIST[idx].current;
	if (currentSubTab.value === current) {
		return;
	}
	router.replace({ query: { ...route.query, tab: idx, more: 5 } });
};

// 기타 상세 정보 불러오는 함수
const fetchMasterDetail = async () => {
	await refetchMasterDetail();
	if (masterDetailData) {
		masterDetailData.value?.master_sector.map((item: GetMasterDetailSectorData) => {
			masterSectorLabel.value.push(item.master_sector_type);
			masterSectorValue.value.push(item.master_sector_ratio);
		});
	}
};

// 구독 여부 확인 함수
const isSubscribed = (targetPk: number) => {
	return !masterListData.value?.master_list_nosub.some((item) => item.master_pk === targetPk);
};
const onClickMoreButton = () => {
	router.replace({ query: { ...route.query, more: Number(moreNumber.value) + 5 } });
};
// 마스터 pk 없는 경우 첫번째 마스터 pk로 변경
const handleGetMasterPk = () => {
	if (masterListData.value && masterListData.value?.master_list_onsub.length > 0) {
		router.replace({ query: { masterPk: masterListData.value?.master_list_onsub[0].master_pk } });
		subYn.value = 1;
		return;
	}
	if (masterListData.value && masterListData.value?.master_list_nosub.length > 0) {
		router.replace({ query: { masterPk: masterListData.value?.master_list_nosub[0].master_pk } });
		subYn.value = 0;
	}
};

// COMMENT : AOS에서는 target: _blank로 새창을 띄울 수 없어 추가된 코드입니다.
watch(
	[masterDetailData],
	() => {
		contentBodies.value = Array.from(document.querySelectorAll('.c_editorContent')); // 모든 요소 선택

		contentBodies.value.forEach((contentBody) => {
			// 기존 리스너 제거 (필요한 경우)
			contentBody.removeEventListener('click', handleLinkClick);

			// 새로운 리스너 추가
			contentBody.addEventListener('click', handleLinkClick);
		});
	},
	{ immediate: true }
);

watch(
	() => currentSubTab.value,
	async () => {
		await refetchMasterEvent();
	}
);

watchEffect(async () => {
	if (masterListData.value && !routePk.value) {
		handleGetMasterPk();
	}
	if (masterListData.value && routePk.value) {
		if (isSubscribed(Number(routePk.value))) {
			subYn.value = 1;
		} else {
			subYn.value = 0;
		}
		await fetchMasterDetail();
		await refetchMasterEvent();
	}
});
</script>

<style lang="scss" scoped>
.container {
	display: flex;
	flex-direction: column;
	gap: 8.8rem;
	max-width: 68rem;
	padding-top: var(--header-height);
	margin: 7.2rem auto 8.8rem;
	@media screen and (max-width: 1280px) {
		gap: 8rem;
		margin: 4rem auto 8rem;
	}
}

.section_characterInfo_container {
	display: flex;
	flex-direction: column;
	gap: 2rem;
}
.section_characterInfo {
	@media screen and (max-width: 1280px) {
		margin-left: var(--space-large);
		margin-right: var(--space-large);
	}
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 0.8rem;
	text-align: center;
	background-color: var(--color-bg-mid);
	padding: 2.4rem 2rem;
	border-radius: 0.8rem;
	border: 1px solid var(--color-base-mid);
	.characterInfo_img {
		height: 10rem;
		object-fit: contain;
	}
	.characterInfo_content {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 0.4rem;
		.content_name {
			font-size: var(--font-s-x-large);
			font-weight: var(--font-w-semi-bold);
			line-height: 2.387rem;
		}
		.content_motto {
			font-size: var(--font-s-regular);
			font-weight: var(--font-w-light);
			color: var(--color-base-light);
			line-height: 2.3rem;
		}
	}
	.characterInfo_subBtn {
		width: 24rem;
		padding: 1.35rem 1.6rem;
		font-size: var(--font-s-regular);
		font-weight: var(--font-w-medium);
		line-height: 2.1rem;
		background-color: var(--color-primary);
		border-radius: 0.6rem;
	}
	.characterInfo_subTxt {
		font-size: var(--font-s-regular);
		font-weight: var(--font-w-medium);
		line-height: 2.1rem;
		color: var(--color-secondary-Blue);
	}
}

.section_stock {
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 3.2rem;
	padding: 0;
	.stock_lists {
		display: flex;
		flex-direction: column;
		gap: 2rem;
		@media screen and (max-width: 1280px) {
			padding-left: var(--space-large);
			padding-right: var(--space-large);
		}
		.list_guide {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			gap: 1.7rem;
			background-color: var(--color-bg-mid);
			padding: 2.4rem 2rem;
			border-radius: 0.8rem;
			margin-bottom: 1rem;
			.guide_txt {
				font-size: var(--font-s-regular);
				font-weight: var(--font-w-light);
				line-height: 2.3rem;
				text-align: center;
				span {
					font-size: var(--font-s-large);
					font-weight: var(--font-w-semi-bold);
					line-height: 2.3rem;
					color: var(--color-secondary);
				}
			}
			.guide_btn {
				width: 24rem;
				padding: 1.35rem 1.6rem;
				font-size: var(--font-s-regular);
				font-weight: var(--font-w-medium);
				line-height: 2.1rem;
				background-color: var(--color-primary);
				border-radius: 0.6rem;
			}
			.btn_more {
				display: flex;
				gap: 0.25rem;
				width: 100%;
				height: 5.2rem;
				margin-top: 1rem;
			}
		}
	}
}

.section_achieve {
	display: flex;
	flex-direction: column;
	gap: 2rem;
	@media screen and (max-width: 1280px) {
		padding-left: var(--space-large);
		padding-right: var(--space-large);
	}
	.achieve_title {
		font-size: var(--font-s-x-large);
		font-weight: var(--font-w-semi-bold);
		line-height: 2.387rem;
	}
	.achieve_content {
		border-radius: 1rem;
		// overflow: hidden;

		.c_editorContent {
			height: 100%;
			border-radius: 1rem;
			:deep(figure) {
				height: 100%;
				border-radius: 1rem;
				div {
					height: 100%;
					border-radius: 1rem;
				}
				iframe {
					border-radius: 1rem;
					@media screen and (max-width: 1280px) {
						width: 100%;
						height: 18.8rem;
					}
				}
			}
		}
	}
}

.section_rate {
	display: flex;
	flex-direction: column;
	gap: 2rem;
	@media screen and (max-width: 1280px) {
		padding-left: var(--space-large);
		padding-right: var(--space-large);
	}
	.rate_title {
		font-size: var(--font-s-x-large);
		font-weight: var(--font-w-semi-bold);
		line-height: 2.387rem;
	}
	.rate_content {
		background-color: var(--color-bg-mid);
		padding: 2rem;
		border-radius: 10px;
	}
}

.section_rule {
	display: flex;
	flex-direction: column;
	gap: 2rem;
	@media screen and (max-width: 1280px) {
		padding-left: var(--space-large);
		padding-right: var(--space-large);
	}
	.rule_title {
		font-size: var(--font-s-x-large);
		font-weight: var(--font-w-semi-bold);
		line-height: 2.387rem;
	}
	.rule_content {
		background-color: var(--color-bg-mid);
		padding: 2rem;
		border-radius: 10px;
	}
}

.section_style {
	display: flex;
	flex-direction: column;
	gap: 2rem;
	@media screen and (max-width: 1280px) {
		padding-left: var(--space-large);
		padding-right: var(--space-large);
	}
	.style_title {
		font-size: var(--font-s-x-large);
		font-weight: var(--font-w-semi-bold);
		line-height: 2.387rem;
	}
	.style_content {
		background-color: var(--color-bg-mid);
		padding: 2rem;
		border-radius: 10px;
	}
}

.section_ratio {
	display: flex;
	flex-direction: column;
	gap: 2.4rem;
	@media screen and (max-width: 1280px) {
		padding-left: var(--space-large);
		padding-right: var(--space-large);
	}
	.ratio_title {
		font-size: var(--font-s-x-large);
		font-weight: var(--font-w-semi-bold);
		line-height: 2.387rem;
	}

	.ratio_btn {
		display: flex;
		justify-content: center;
		.btn_subscribe {
			width: 24rem;
			font-size: var(--font-s-regular);
			font-weight: var(--font-w-semi-bold);
			line-height: 2.1rem;
			margin-top: 4rem;
		}
	}
}
</style>
